import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import PageShell, { PageHero } from "./PageShell";
import FAQV2 from "../components/FAQV2";
import DoorsV2 from "../components/DoorsV2";
import { Arrow } from "../components/Primitives";
import { V2, pickLang } from "../copy";
import { route } from "../paths";

const FAQPageV2: React.FC = () => {
  const { currentLanguage } = useLanguage();
  const lang = pickLang(currentLanguage);
  const isFr = lang === "fr";
  const c = V2[lang].faq;
  const all = [...c.items, ...c.extra];

  return (
    <PageShell
      seo={{
        title: isFr
          ? "FAQ nettoyage de sneakers : délais, prix, collecte | Lave Tes Baskets"
          : "Sneaker cleaning FAQ: turnaround, prices, pickup | Lave Tes Baskets",
        description: isFr
          ? "Quelles chaussures acceptez-vous ? Quels délais ? Combien ça coûte ? Comment préparer ses paires ? Toutes les réponses sur le nettoyage de baskets par Lave Tes Baskets."
          : "Which shoes do you accept? How long does it take? How much does it cost? How to prepare your pairs? All the answers on sneaker cleaning by Lave Tes Baskets.",
        canonicalPath: route(lang, "faq"),
        jsonLd: [
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: all.map(([q, a]) => ({
              "@type": "Question",
              name: q,
              acceptedAnswer: { "@type": "Answer", text: a },
            })),
          },
        ],
      }}
    >
      <PageHero
        crumbs={[
          { label: isFr ? "Accueil" : "Home", to: route(lang) },
          { label: "FAQ" },
        ]}
        index="06"
        eyebrow="FAQ"
        title={
          isFr ? (
            <>
              Questions, <em className="italic text-tangerine">réponses.</em>
            </>
          ) : (
            <>
              Questions, <em className="italic text-tangerine">answers.</em>
            </>
          )
        }
        lede={
          isFr
            ? "Tout ce qu'on nous demande le plus souvent. Il manque quelque chose ? Écrivez-nous."
            : "Everything we get asked most often. Missing something? Write to us."
        }
        actions={
          <a href={`mailto:${V2[lang].cta.email}`} className="v2-btn v2-btn-ghost">
            {V2[lang].cta.email}
            <Arrow />
          </a>
        }
      />
      <FAQV2 standalone />
      <section className="bg-ink py-16 text-bone sm:py-24">
        <div className="mx-auto max-w-[1400px] px-4 sm:px-6">
          <DoorsV2 />
          <div className="mt-8 text-center">
            <Link to={route(lang)} className="v2-link text-sm text-bone/70">
              {isFr ? "Retour à l'accueil" : "Back to home"}
            </Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
};

export default FAQPageV2;
